import { Fingerprint, Globe2, MessageSquareText, ShieldCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  ConnectionLines,
  GraphicCard,
  IllustrationFrame,
  StackedCard,
  VerifiedPill,
} from './shared'

function ConversationBubbles() {
  return (
    <g>
      <rect x="121" y="93" width="103" height="43" rx="12" className="fill-muted" />
      <path
        d="M133 109H209 M133 120H186"
        className="stroke-muted-foreground/30"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <rect
        x="143"
        y="146"
        width="103"
        height="43"
        rx="12"
        className="fill-primary/15 stroke-primary/30"
      />
      <path
        d="M155 162H231 M155 174H208"
        className="stroke-primary/50"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <rect x="121" y="199" width="94" height="31" rx="10" className="fill-muted" />
      <path
        d="M133 214H199"
        className="stroke-muted-foreground/30"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </g>
  )
}

function PhoneExtraction() {
  return (
    <g>
      <StackedCard x={105} y={20} width={158} height={250} rx={24} />
      <rect x="159" y="31" width="50" height="5" rx="3" className="fill-muted-foreground/30" />
      <MessageSquareText x="125" y="54" width="20" height="20" className="text-primary-strong" />
      <path
        d="M155 60H239 M155 69H211"
        className="stroke-muted-foreground/20"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <ConversationBubbles />
      <ShieldCheck x="176" y="239" width="17" height="17" className="text-primary-strong" />
    </g>
  )
}

export function MobileForensicsIllustration() {
  const { t } = useTranslation()
  const key = 'whatsNew.slides.mobileForensics.graphic'
  return (
    <IllustrationFrame label={t(`${key}.description`)}>
      <ConnectionLines d="M263 167H340Q362 167 362 145V63H433 M362 145H466 M362 145V219H405" />
      <PhoneExtraction />
      <circle cx="362" cy="145" r="5" className="fill-primary" />
      <GraphicCard card={{ x: 433, y: 34, label: t(`${key}.chats`), icon: MessageSquareText }} />
      <GraphicCard card={{ x: 466, y: 116, label: t(`${key}.activity`), icon: Globe2 }} />
      <GraphicCard card={{ x: 405, y: 190, label: t(`${key}.evidence`), icon: Fingerprint }} />
      <VerifiedPill label={t(`${key}.traceable`)} y={260} />
    </IllustrationFrame>
  )
}
